import React from "react";
import PageHero from "./PageHero";
import Section from "./Section";
import Reveal from "./Reveal";
import GlowCard from "./GlowCard";

/**
 * LegalPage — wrapper for Privacy, Terms, Cookie pages.
 * Pass `eyebrow`, `title`, `lastUpdated`, and children (the content sections).
 *
 * Use these helpers inside children for consistent typography:
 *   <LegalSection title="..."> ... </LegalSection>
 */
const LegalPage = ({ eyebrow, eyebrowIcon, title, lastUpdated, children }) => {
  return (
    <div className="min-h-screen text-[var(--text-primary)]">
      <PageHero
        eyebrow={eyebrow}
        eyebrowIcon={eyebrowIcon}
        title={title}
        description={lastUpdated && `Last updated: ${lastUpdated}`}
      />
      <Section size="sm">
        <Reveal variant="up">
          <GlowCard variant="liquid" className="p-7 sm:p-10 lg:p-12 max-w-4xl mx-auto space-y-8">
            {children}
          </GlowCard>
        </Reveal>
      </Section>
    </div>
  );
};

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="text-xl sm:text-2xl font-display font-semibold mb-4 gradient-text-cool">
      {title}
    </h2>
    <div className="text-[var(--text-secondary)] leading-relaxed space-y-4 text-sm sm:text-base">
      {children}
    </div>
  </section>
);

export const LegalList = ({ children, ordered = false }) => {
  const Tag = ordered ? "ol" : "ul";
  return (
    <Tag className={`${ordered ? "list-decimal" : "list-disc"} list-outside ml-5 space-y-2`}>
      {children}
    </Tag>
  );
};

export const LegalContactBox = ({ name, address, email, phone }) => (
  <div className="rounded-2xl border border-[color:var(--border-default)] bg-[color:var(--surface-1)]/50 p-5 mt-3">
    <p className="font-semibold text-[var(--text-primary)]">{name}</p>
    {address && <p className="text-sm mt-1">{address}</p>}
    {email && <p className="text-sm mt-1">Email: <a href={`mailto:${email}`} className="text-[var(--brand-primary-light)] hover:underline">{email}</a></p>}
    {phone && <p className="text-sm mt-1">Phone: <a href={`tel:${phone}`} className="text-[var(--brand-primary-light)] hover:underline">{phone}</a></p>}
  </div>
);

export default LegalPage;
